var tjq = jQuery;
var stGlobals = {};
stGlobals.isMobile = (/(Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|windows phone)/.test(navigator.userAgent));
stGlobals.isMobileWebkit = /WebKit/.test(navigator.userAgent) && /Mobile/.test(navigator.userAgent);
stGlobals.isIOS = (/iphone|ipad|ipod/gi).test(navigator.appVersion);
String.prototype.lpad = function(padString, length) {
    var str = this;
    while (str.length < length) str = padString + str;
    return str
}
tjq.fn.removeClassPrefix = function(prefix) {
    this.each(function(i, el) {
        var classes = el.className.split(" ").filter(function(c) {
            return c.lastIndexOf(prefix, 0) !== 0
        });
        el.className = classes.join(" ")
    });
    return this
};
(function(window, document, $) {
    var middleblock;
    var prototype = $.fn;
    middleblock = prototype.middleblock = function() {
        var $this = this;
        if ($(this).is(":visible")) {
            $this.bind("set.middleblock", set_middle_block).trigger('set.middleblock')
        }
        return $this
    };

    function set_middle_block(event, value) {
        var $this = $(this);
        var $middleItem = $this.find(".middle-item");
        if ($middleItem.length < 1) {
            $middleItem = $this.children("img")
        }
        if ($middleItem.length < 1) {
            return
        }
        var width = $middleItem.width();
        var height = $middleItem.height();
        if ($this.width() <= 1) {
            var parentObj = $this;
            while (parentObj.width() <= 1) {
                parentObj = parentObj.parent()
            }
            $this.css("width", parentObj.width() + "px")
        }
        $this.css("position", "relative");
        $middleItem.css("position", "absolute");
        if ($this.hasClass("middle-block-auto-height")) {
            $this.removeClass("middle-block-auto-height");
            $this.height(0)
        }
        if ($this.height() <= 1) {
            var parentObj = $this;
            while (parentObj.height() <= 1) {
                if (parentObj.css("float") == "left" && parentObj.index() == 0 && parentObj.next().length > 0) {
                    parentObj = parentObj.next()
                } else if (parentObj.css("float") == "left" && parentObj.index() > 0) {
                    parentObj = parentObj.prev()
                } else {
                    parentObj = parentObj.parent()
                }
            }
            $this.css("height", parentObj.outerHeight() + "px");
            $this.addClass("middle-block-auto-height");
            width = $middleItem.width();
            height = $middleItem.height();
            if (height <= 1) {
                height = parentObj.outerHeight()
            }
        }
        $middleItem.css("top", "50%");
        $middleItem.css("margin-top", "-" + (height / 2) + "px");
        if (width >= 1) {
            $middleItem.css("left", "50%");
            $middleItem.css("margin-left", "-" + (width / 2) + "px")
        } else {
            $middleItem.css("left", "0")
        }
    }
}(this, document, jQuery));
(function(a) {
    a.fn.countTo = function(g) {
        g = g || {};
        return a(this).each(function() {
            function e(a) {
                a = b.formatter.call(h, a, b);
                f.html(a)
            }
            var b = a.extend({}, a.fn.countTo.defaults, {
                    from: a(this).data("from"),
                    to: a(this).data("to"),
                    speed: a(this).data("speed"),
                    refreshInterval: a(this).data("refresh-interval"),
                    decimals: a(this).data("decimals")
                }, g),
                j = Math.ceil(b.speed / b.refreshInterval),
                l = (b.to - b.from) / j,
                h = this,
                f = a(this),
                k = 0,
                c = b.from,
                d = f.data("countTo") || {};
            f.data("countTo", d);
            d.interval && clearInterval(d.interval);
            d.interval = setInterval(function() {
                c += l;
                k++;
                e(c);
                "function" == typeof b.onUpdate && b.onUpdate.call(h, c);
                k >= j && (f.removeData("countTo"), clearInterval(d.interval), c = b.to, "function" == typeof b.onComplete && b.onComplete.call(h, c))
            }, b.refreshInterval);
            e(c)
        })
    };
    a.fn.countTo.defaults = {
        from: 0,
        to: 0,
        speed: 1E3,
        refreshInterval: 100,
        decimals: 0,
        formatter: function(a, e) {
            return a.toFixed(e.decimals)
        },
        onUpdate: null,
        onComplete: null
    }
})(jQuery);
(function(window, document, $) {
    var onstage;
    var prototype = $.fn;
    onstage = prototype.onstage = function() {
        var scrollTop = tjq(window).scrollTop();
        var windowHeight = tjq(window).height();
        var $this = this;
        if ($this.offset().top + $this.height() * 0.9 <= scrollTop + windowHeight && $this.offset().top + $this.height() * 0.9 > scrollTop) {
            return !0
        }
        return !1
    }
}(this, document, jQuery));
(function($) {
    var stp, SoapPopup = function() {};
    SoapPopup.prototype = {
        constructor: SoapPopup,
        init: function() {},
        open: function(options, obj) {
            if (typeof options == "undefined") {
                options = {}
            }
            var wrapObj = options.wrapId ? "#" + options.wrapId : ".opacity-overlay";
            if ($(wrapObj).length < 1) {
                var idStr = options.wrapId ? " id='" + options.wrapId + "'" : "";
                $("<div class='opacity-overlay' " + idStr + "><div class='container'><div class='popup-wrapper'><i class='fas fa-spinner fa-spin spinner'></i><div class='col-xs-12 col-sm-9 popup-content' style='direction: ltr'></div></div></div></div>").appendTo("body")
            }
            stp.wrap = $(wrapObj);
            stp.content = stp.wrap.find(".popup-content");
            stp.spinner = stp.wrap.find(".spinner");
            stp.contentContainer = stp.wrap.find(".popup-wrapper");
            if (stGlobals.isMobile) {
                stp.wrap.css({
                    height: $(document).height(),
                    position: 'absolute'
                });
                stp.contentContainer.css("top", $(window).scrollTop())
            }
            stp.updateSize();
            if (options.type == "ajax") {
                stp.content.html('');
                stp.content.height('auto').css("visibility", "hidden");
                stp.wrap.fadeIn();
                stp.spinner.show();
                $("body").addClass("overlay-open");
                $.ajax({
                    url: obj.attr("href"),
                    type: 'post',
                    dataType: 'html',
                    success: function(html) {
                        stp.content.html(html);
                        if (options.callBack) {
                            options.callBack(stp)
                        }
                        setTimeout(function() {
                            stp.content.css("visibility", "visible");
                            stp.spinner.hide()
                        }, 100)
                    }
                })
            } else if (options.type == "map") {
                stp.wrap.fadeIn();
                stp.spinner.show();
                var lngltd = options.lngltd.split(",");
                var contentWidth = stp.content.width();
                stp.content.gmap3({
                    clear: {
                        name: "marker",
                        last: !0
                    }
                });
                var zoom = options.zoom ? parseInt(options.zoom, 10) : 12;
                stp.content.height(contentWidth * 0.5).gmap3({
                    map: {
                        options: {
                            center: lngltd,
                            zoom: zoom
                        }
                    },
                    marker: {
                        values: [{
                            latLng: lngltd
                        }],
                        options: {
                            draggable: !1
                        },
                    }
                });
                $("body").addClass("overlay-open")
            } else {
                var sourceId = obj.attr("href");
                if (typeof sourceId == "undefined") {
                    sourceId = obj.data("target")
                }
                stp.content.children().hide();
                if (stp.content.children(sourceId).length > 0) {} else {
                    $(sourceId).appendTo(stp.content)
                }
                $(sourceId).show();
                stp.spinner.hide();
                stp.wrap.fadeIn(function() {
                    $(sourceId).find(".input-text").eq(0).focus();
                    $("body").addClass("overlay-open")
                })
            }
        },
        close: function() {
            $("body").removeClass("overlay-open");
            $("html").css("overflow", "");
            $("html").css("margin-right", "");
            stp.spinner.hide();
            stp.wrap.fadeOut()
        },
        updateSize: function() {
            if (stGlobals.isIOS) {
                var zoomLevel = document.documentElement.clientWidth / window.innerWidth;
                var height = window.innerHeight * zoomLevel;
                stp.contentContainer.css('height', height)
            } else if (stGlobals.isMobile) {
                stp.contentContainer.css('height', $(window).height())
            }
        },
        getScrollbarSize: function() {
            if (document.body.scrollHeight <= $(window).height()) {
                return 0
            }
            if (stp.scrollbarSize === undefined) {
                var scrollDiv = document.createElement("div");
                scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
                document.body.appendChild(scrollDiv);
                stp.scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
                document.body.removeChild(scrollDiv)
            }
            return stp.scrollbarSize
        }
    }
    $.fn.soapPopup = function(options) {
        stp = new SoapPopup();
        stp.init();
        $(document).bind('keydown', function(e) {
            var key = e.keyCode;
            if ($(".opacity-overlay:visible").length > 0 && key === 27) {
                e.preventDefault();
                stp.close()
            }
        });
        $(document).on("click touchend", ".opacity-overlay", function(e) {
            if ($("body").hasClass("overlay-open") && !$(e.target).is(".opacity-overlay .popup-content *")) {
                e.preventDefault();
                stp.close()
            }
        });
        $(document).on("click touchend", ".opacity-overlay [data-dismiss='modal']", function(e) {
            stp.close()
        });
        $(window).resize(function() {
            stp.updateSize()
        });
        stp.open(options, $(this));
        return $(this)
    }
})(jQuery);
if (typeof enableChaser == "undefined") {
    enableChaser = $('header#header.navbar-static-top').data('chaser')
}
tjq("body").on("click", "a.popup-gallery", function(e) {
    e.preventDefault();
    return !1
});

function changeTraveloElementUI() {
    tjq(".selector select").each(function() {
        var obj = tjq(this);
        if (obj.parent().children(".custom-select").length < 1) {
            obj.after("<span class='custom-select'>" + obj.children("option:selected").html() + "</span>");
            if (obj.hasClass("white-bg")) {
                obj.next("span.custom-select").addClass("white-bg")
            }
            if (obj.hasClass("full-width")) {
                obj.next("span.custom-select").addClass("full-width")
            }
        }
    });
    tjq("body").on("change", ".selector select", function() {
        if (tjq(this).next("span.custom-select").length > 0) {
            tjq(this).next("span.custom-select").text(tjq(this).find("option:selected").text())
        }
    });
    tjq("body").on("keydown", ".selector select", function() {
        if (tjq(this).next("span.custom-select").length > 0) {
            tjq(this).next("span.custom-select").text(tjq(this).find("option:selected").text())
        }
    });
    tjq(".fileinput input[type=file]").each(function() {
        var obj = tjq(this);
        if (obj.parent().children(".custom-fileinput").length < 1) {
            obj.after('<input type="text" class="custom-fileinput" />');
            if (typeof obj.data("placeholder") != "undefined") {
                obj.next(".custom-fileinput").attr("placeholder", obj.data("placeholder"))
            }
            if (typeof obj.prop("class") != "undefined") {
                obj.next(".custom-fileinput").addClass(obj.prop("class"))
            }
            obj.parent().css("line-height", obj.outerHeight() + "px")
        }
    });
    tjq(".fileinput input[type=file]").on("change", function() {
        var fileName = this.value;
        var slashIndex = fileName.lastIndexOf("\\");
        if (slashIndex == -1) {
            slashIndex = fileName.lastIndexOf("/")
        }
        if (slashIndex != -1) {
            fileName = fileName.substring(slashIndex + 1)
        }
        tjq(this).next(".custom-fileinput").val(fileName)
    });
    tjq(".checkbox input[type='checkbox'], .radio input[type='radio']").each(function() {
        if (tjq(this).is(":checked")) {
            tjq(this).closest(".checkbox").addClass("checked");
            tjq(this).closest(".radio").addClass("checked")
        }
    });
    tjq(".checkbox input[type='checkbox']").bind("change", function() {
        if (tjq(this).is(":checked")) {
            tjq(this).closest(".checkbox").addClass("checked")
        } else {
            tjq(this).closest(".checkbox").removeClass("checked")
        }
    });
    tjq(".radio input[type='radio']").bind("change", function(event, ui) {
        if (tjq(this).is(":checked")) {
            var name = tjq(this).prop("name");
            if (typeof name != "undefined") {
                tjq(".radio input[name='" + name + "']").closest('.radio').removeClass("checked")
            }
            tjq(this).closest(".radio").addClass("checked")
        }
    });
    try {
        tjq('input, textarea').placeholder()
    } catch (e) {}
}
tjq(document).ready(function() {
    changeTraveloElementUI();
    if (stGlobals.isMobile) {
        tjq("body").addClass("is-mobile")
    }
    if (stGlobals.isMobileWebkit) {
        tjq(".parallax").css("background-attachment", "scroll")
    }
});

function displayPhotoGallery($item) {
    if (!tjq.fn.flexslider || $item.length < 1 || $item.is(":hidden")) {
        return
    }
    var dataAnimation = $item.data("animation");
    var dataSync = $item.data("sync");
    if (typeof dataAnimation == "undefined") {
        dataAnimation = "slide"
    }
    var dataFixPos = $item.data("fix-control-nav-pos");
    var callFunc = $item.data("func-on-start");
    $item.flexslider({
        animation: dataAnimation,
        controlNav: !0,
        animationLoop: !0,
        slideshow: !0,
        pauseOnHover: !0,
        sync: dataSync,
        start: function(slider) {
            if (typeof dataFixPos != "undefined" && dataFixPos == "1") {
                var height = tjq(slider).find(".slides img").height();
                tjq(slider).find(".flex-control-nav").css("top", (height - 44) + "px")
            }
            if (typeof callFunc != "undefined") {
                try {
                    eval(callFunc + "();")
                } catch (e) {}
            }
        },
    })
}

function displayImageCarousel($item) {
    if (!tjq.fn.flexslider || $item.length < 1 || $item.is(":hidden")) {
        return
    }
    var dataAnimation = $item.data("animation");
    var dataItemWidth = $item.data("item-width");
    var dataItemMargin = $item.data("item-margin");
    var dataSync = $item.data("sync");
    if (typeof dataAnimation == "undefined") {
        dataAnimation = "slide"
    }
    if (typeof dataItemWidth == "undefined") {
        dataItemWidth = 70
    }
    if (typeof dataItemMargin == "undefined") {
        dataItemMargin = 10
    }
    dataItemWidth = parseInt(dataItemWidth, 10);
    dataItemMargin = parseInt(dataItemMargin, 10);
    var dataAnimationLoop = !0;
    var dataSlideshow = !1;
    if (typeof dataSync == "undefined") {
        dataSync = "";
        dataSlideshow = !0
    }
    $item.flexslider({
        animation: dataAnimation,
        controlNav: !0,
        animationLoop: dataAnimationLoop,
        slideshow: dataSlideshow,
        itemWidth: dataItemWidth,
        itemMargin: dataItemMargin,
        minItems: 2,
        pauseOnHover: !0,
        asNavFor: dataSync,
        start: function(slider) {
            if (dataSync != "") {
                tjq(slider).find(".slides > li").height(dataItemWidth);
                tjq(slider).find(".slides > li > img").each(function() {
                    if (tjq(this).width() < 1) {
                        tjq(this).load(function() {
                            tjq(this).parent().middleblock()
                        })
                    } else {
                        tjq(this).parent().middleblock()
                    }
                })
            } else {
                tjq(slider).find(".middle-block img, .middle-block .middle-item").each(function() {
                    if (tjq(this).width() < 1) {
                        tjq(this).load(function() {
                            tjq(this).closest(".middle-block").middleblock()
                        })
                    } else {
                        tjq(this).closest(".middle-block").middleblock()
                    }
                })
            }
        },
        after: function(slider) {
            if (slider.currentItem == 0) {
                target = 0;
                if (slider.transitions) {
                    target = (slider.vars.direction === "vertical") ? "translate3d(0," + target + ",0)" : "translate3d(" + target + ",0,0)";
                    slider.container.css("-" + slider.pfx + "-transition-duration", "0s");
                    slider.container.css("transition-duration", "0s")
                }
                slider.args[slider.prop] = target;
                slider.container.css(slider.args);
                slider.container.css('transform', target)
            }
        }
    })
}
tjq(window).on('load', function() {
    tjq("body").on("click", "#back-to-top", function(e) {
        e.preventDefault();
        tjq("html,body").animate({
            scrollTop: 0
        }, 1000)
    });
    if (tjq('#mobile-search-tabs').length > 0) {
        var mobile_search_tabs_slider = tjq('#mobile-search-tabs').bxSlider({
            mode: 'fade',
            infiniteLoop: !1,
            hideControlOnEnd: !0,
            touchEnabled: !0,
            pager: !1,
            onSlideAfter: function($slideElement, oldIndex, newIndex) {
                tjq('a[href="' + tjq($slideElement).children("a").attr("href") + '"]').tab('show')
            }
        })
    }
    tjq(".mobile-menu ul.menu > li.menu-item-has-children").each(function(index) {
        var menuItemId = "mobile-menu-submenu-item-" + index;
        tjq('<button class="dropdown-toggle collapsed" data-toggle="collapse" data-target="#' + menuItemId + '"></button>').insertAfter(tjq(this).children("a"));
        tjq(this).children("ul").prop("id", menuItemId);
        tjq(this).children("ul").addClass("collapse");
        tjq("#" + menuItemId).on("show.bs.collapse", function() {
            tjq(this).parent().addClass("open")
        });
        tjq("#" + menuItemId).on("hidden.bs.collapse", function() {
            tjq(this).parent().removeClass("open")
        })
    });
    tjq(".middle-block").middleblock();

    function fixPositionSubmenu() {
        tjq("#main-menu .menu li.menu-item-has-children > ul, .ribbon ul.menu.mini").each(function(e) {
            if (tjq(this).closest(".megamenu").length > 0) {
                return
            }
            var leftPos = tjq(this).parent().offset().left + tjq(this).parent().width();
            if (leftPos + tjq(this).width() > tjq("body").width()) {
                tjq(this).addClass("left")
            } else {
                tjq(this).removeClass("left")
            }
        })
    }
    fixPositionSubmenu();
    if (enableChaser == 1 && tjq('#content').length > 0 && tjq('#main-menu ul.menu').length > 0) {
        var forchBottom;
        var chaser = tjq('#main-menu ul.menu').clone().hide().appendTo(document.body).wrap("<div class='chaser hidden-mobile'><div class='container'></div></div>");
        var logo = $('h1.logo.navbar-brand').clone();
        var img = tjq(logo).find('img');
        tjq(img).prop('src', tjq(img).data('sticky'));
        tjq(img).removeAttr('width');
        tjq(logo).insertBefore('.chaser .menu');
        var forch = tjq('#content').first();
        forchBottom = forch.offset().top + 2;
        tjq(window).on('scroll', function() {
            var top = tjq(document).scrollTop();
            if (tjq(".chaser").is(":hidden") && top > forchBottom) {
                tjq(".chaser").slideDown(300)
            } else if (tjq(".chaser").is(":visible") && top < forchBottom) {
                tjq(".chaser").slideUp(200)
            }
        });
        tjq(window).on('resize', function() {
            var top = tjq(document).scrollTop();
            if (tjq(".chaser").is(":hidden") && top > forchBottom) {
                tjq(".chaser").slideDown(300)
            } else if (tjq(".chaser").is(":visible") && top < forchBottom) {
                tjq(".chaser").slideUp(200)
            }
        });
        tjq(".chaser").css("visibility", "hidden");
        chaser.show();
        fixPositionMegaMenu(".chaser");
        tjq(".chaser .megamenu-menu").removeClass("light");
        tjq(".chaser").hide();
        tjq(".chaser").css("visibility", "visible")
    }
    tjq(".toggle-container .panel-collapse").each(function() {
        if (!tjq(this).hasClass("in")) {
            tjq(this).closest(".panel").find("[data-toggle=collapse]").addClass("collapsed")
        }
    });
    tjq(".toggle-container.with-image").each(function() {
        var type = "";
        var duration = "1s";
        if (typeof tjq(this).data("image-animation-type") != "undefined") {
            type = tjq(this).data("image-animation-type")
        }
        if (typeof tjq(this).data("image-animation-duration") != "undefined") {
            duration = tjq(this).data("image-animation-duration")
        }
        var imageHtml = '<div class="image-container';
        if (type != "") {
            imageHtml += ' animated" data-animation-type="' + type + '" data-animation-duration="' + duration
        }
        imageHtml += '"><img src="" alt="" /></div>';
        tjq(this).prepend(imageHtml);
        if (tjq(this).find(".panel-collapse.in").length > 0) {
            var activeImg = tjq(this).find(".panel-collapse.in").parent().children("img");
            var src = activeImg.attr("src");
            var width = activeImg.attr("width");
            var height = activeImg.attr("height");
            var alt = activeImg.attr("alt");
            var imgObj = tjq(this).find(".image-container img");
            imgObj.attr("src", src);
            if (typeof width != "undefined") {
                imgObj.attr("width", width)
            }
            if (typeof height != "undefined") {
                imgObj.attr("height", height)
            }
            if (typeof alt != "undefined") {
                imgObj.attr("alt", alt)
            }
            tjq(this).children(".image-container").show()
        }
    });
    tjq('.toggle-container.with-image').on('show.bs.collapse', function(e) {
        var activeImg = tjq(e.target).parent().children("img");
        if (activeImg.length > 0) {
            var src = activeImg.attr("src");
            var width = activeImg.attr("width");
            var height = activeImg.attr("height");
            var alt = activeImg.attr("alt");
            var imgObj = tjq(this).find(".image-container img");
            imgObj.attr("src", src);
            if (typeof width != "undefined") {
                imgObj.attr("width", width)
            }
            if (typeof height != "undefined") {
                imgObj.attr("height", height)
            }
            if (typeof alt != "undefined") {
                imgObj.attr("alt", alt)
            }
            imgObj.parent().css("visibility", "hidden");
            imgObj.parent().removeClass(imgObj.parent().data("animation-type"));
            setTimeout(function() {
                imgObj.parent().addClass(imgObj.parent().data("animation-type"));
                imgObj.parent().css("visibility", "visible")
            }, 10)
        }
    });
    tjq('.toggle-container.with-image').on('shown.bs.collapse', function(e) {});
    tjq("body").on("click", ".alert > .close, .info-box > .close", function() {
        tjq(this).parent().fadeOut(300)
    });
    tjq("[data-toggle=tooltip]").tooltip();

    function fixTestimonialHeight(slider) {
        var maxHeight = 0;
        tjq(slider).find(".slides > li").each(function() {
            tjq(this).css("height", "auto");
            if (tjq(this).height() > maxHeight) {
                maxHeight = tjq(this).height()
            }
        });
        tjq(slider).find(".slides > li").height(maxHeight)
    }

    function displayTestimonials() {
        try {
            if (tjq('.testimonial.style1').length > 0 && tjq('.testimonial.style1').is(":visible")) {
                tjq('.testimonial.style1').flexslider({
                    namespace: "testimonial-",
                    animation: "slide",
                    controlNav: !0,
                    animationLoop: !1,
                    directionNav: !1,
                    slideshow: !1,
                    start: fixTestimonialHeight
                })
            }
        } catch (e) {}
        try {
            if (tjq('.testimonial.style2').length > 0 && tjq('.testimonial.style2').is(":visible")) {
                tjq('.testimonial.style2').flexslider({
                    namespace: "testimonial-",
                    animation: "slide",
                    controlNav: !1,
                    animationLoop: !1,
                    directionNav: !0,
                    slideshow: !1,
                    start: fixTestimonialHeight
                })
            }
        } catch (e) {}
        try {
            if (tjq('.testimonial.style3').length > 0 && tjq('.testimonial.style3').is(":visible")) {
                tjq('.testimonial.style3').flexslider({
                    namespace: "testimonial-",
                    controlNav: !1,
                    animationLoop: !1,
                    directionNav: !0,
                    slideshow: !1,
                    start: fixTestimonialHeight
                })
            }
        } catch (e) {}
    }
    displayTestimonials();
    tjq('.image-carousel').each(function() {
        displayImageCarousel(tjq(this))
    });
    tjq('.photo-gallery').each(function() {
        displayPhotoGallery(tjq(this))
    });
    tjq('a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
        var contentId = tjq(e.target).attr("href");
        if (tjq(contentId).find(".image-carousel").length > 0) {
            displayImageCarousel(tjq(contentId).find(".image-carousel"))
        }
        if (tjq(contentId).find(".photo-gallery").length > 0) {
            displayPhotoGallery(tjq(contentId).find(".photo-gallery"))
        }
        if (tjq(contentId).find(".testimonial").length > 0) {
            displayTestimonials()
        }
        tjq(contentId).find(".middle-block").middleblock()
    });
    tjq("body").on("click", "a.popup-gallery", function(e) {
        e.preventDefault();
        tjq(this).soapPopup({
            type: "ajax",
            wrapId: "soap-gallery-popup",
            callBack: function(stp) {
                if (stp.wrap.find('.image-carousel').length > 0) {
                    displayImageCarousel(stp.wrap.find('.image-carousel'))
                }
                if (stp.wrap.find('.photo-gallery').length > 0) {
                    displayPhotoGallery(stp.wrap.find('.photo-gallery'))
                }
            }
        })
    });
    tjq("body").on("click", ".popup-map", function(e) {
        var lngltd = tjq(this).data("box");
        if (typeof lngltd != "undefined") {
            e.preventDefault();
            tjq(this).soapPopup({
                type: "map",
                zoom: 12,
                wrapId: "soap-map-popup",
                lngltd: lngltd
            })
        }
    });
    tjq("body").on("click", ".soap-popupbox", function(e) {
        e.preventDefault();
        var sourceId = tjq(this).attr("href");
        if (typeof sourceId == "undefined") {
            sourceId = tjq(this).data("target")
        }
        if (typeof sourceId == "undefined") {
            return
        }
        if (tjq(sourceId).length < 1) {
            return
        }
        tjq(this).soapPopup({
            wrapId: "soap-popupbox",
        })
    });
    tjq(".style-changer .design-skins a").click(function(e) {
        e.preventDefault();
        tjq(this).closest("ul").children("li").removeClass("active");
        tjq(this).parent().addClass("active")
    });
    tjq("#style-changer .style-toggle").click(function(e) {
        e.preventDefault();
        if (tjq(this).hasClass("open")) {
            tjq("#style-changer").addClass("opened");
            tjq(this).removeClass("open");
            tjq(this).addClass("close")
        } else {
            tjq("#style-changer").removeClass("opened");
            tjq(this).removeClass("close");
            tjq(this).addClass("open")
        }
    });
    tjq(".filters-container .filters-option a").click(function(e) {
        e.preventDefault();
        if (tjq(this).parent().hasClass("active")) {
            tjq(this).parent().removeClass("active")
        } else {
            tjq(this).parent().addClass("active")
        }
    });
    tjq(".sort-trip a").click(function(e) {
        e.preventDefault();
        tjq(this).parent().parent().children().removeClass("active");
        tjq(this).parent().addClass("active")
    });
    tjq(".location-reload").click(function(e) {
        e.preventDefault();
        var url = tjq(this).prop("href").split("#")[0];
        if (window.location.href.indexOf(url) != -1) {
            var hash = tjq(this).prop("href").split("#")[1];
            if (typeof hash != "undefined" && hash != "" && tjq("a[href='#" + hash + "']").length > 0) {
                tjq("a[href='#" + hash + "']").tab('show')
            }
        } else {
            window.location.href = tjq(this).prop("href")
        }
    });

    function fixPromoBoxHeight() {
        tjq(".promo-box").each(function() {
            if (tjq(this).find(".content-section").css("float") == "right") {
                var maxHeight = tjq(this).find(".image-container > img").height();
                tjq(this).find(".content-section .table-wrapper").css("height", "auto");
                var calcPaddingTop = tjq(".content-section").css("padding-top");
                var calcPaddingBottom = tjq(".content-section").css("padding-bottom");
                var calcPadding = 0;
                try {
                    calcPadding = parseInt(calcPaddingTop, 10) + parseInt(calcPaddingBottom, 10)
                } catch (e) {}
                var contentHeight = tjq(this).find(".content-section >.table-wrapper").length > 0 ? tjq(this).find(".content-section > .table-wrapper").height() + calcPadding : tjq(this).find(".content-section").innerHeight();
                if (maxHeight < contentHeight) {
                    maxHeight = contentHeight
                } else {
                    maxHeight += 15
                }
                tjq(this).find(".image-container").height(maxHeight);
                tjq(this).find(".content-section").innerHeight(maxHeight);
                tjq(this).find(".content-section .table-wrapper").css("height", "100%");
                tjq(this).find(".image-container").css("margin-left", "-5%");
                tjq(this).find(".image-container").css("position", "relative");
                tjq(this).find(".image-container > img").css("position", "absolute");
                tjq(this).find(".image-container > img").css("bottom", "0");
                tjq(this).find(".image-container > img").css("left", "0")
            } else {
                tjq(this).find(".image-container").css("height", "auto");
                tjq(this).find(".image-container").css("margin", "0");
                tjq(this).find(".content-section").css("height", "auto");
                tjq(this).find(".image-container > img").css("position", "static")
            }
            if (!tjq(this).find(".image-container > img").hasClass("animated")) {
                tjq(this).find(".image-container > img").css("visibility", "visible")
            }
        })
    }
    fixPromoBoxHeight();
    if (tjq.fn.fitVids) {
        tjq('.full-video').fitVids()
    }
    tjq(".go-back").click(function(e) {
        e.preventDefault();
        window.history.go(-1)
    });
    var traveloLocationHash = window.location.hash;
    if (traveloLocationHash != "") {
        traveloLocationHash = escape(traveloLocationHash.replace("#", ""));
        if (tjq('a[href="#' + traveloLocationHash + '"]').length > 0) {
            setTimeout(function() {
                tjq('a[href="#' + traveloLocationHash + '"]').tab('show')
            }, 100)
        }
    }
    /*if (!stGlobals.isMobileWebkit && tjq(".parallax").length > 0) {
        tjq.stellar({
            responsive: !0,
            horizontalScrolling: !1
        })
    }*/

    tjq("body").on("click", function(e) {
        var target = tjq(e.target);
        if (!target.is(".mobile-topnav .ribbon.opened *")) {
            tjq(".mobile-topnav .ribbon.opened > .menu").toggle();
            tjq(".mobile-topnav .ribbon.opened").removeClass("opened")
        }
    });
    tjq(".mobile-topnav .ribbon > a").on("click", function(e) {
        e.preventDefault();
        if (tjq(".mobile-topnav .ribbon.opened").length > 0 && !tjq(this).parent().hasClass("opened")) {
            tjq(".mobile-topnav .ribbon.opened > .menu").toggle();
            tjq(".mobile-topnav .ribbon.opened").removeClass("opened")
        }
        tjq(this).parent().toggleClass("opened");
        tjq(this).parent().children(".menu").toggle(200);
        if (tjq(this).parent().hasClass("opened") && tjq(this).parent().children(".menu").offset().left + tjq(this).parent().children(".menu").width() > tjq("body").width()) {
            var offsetX = tjq(this).parent().children(".menu").offset().left + tjq(this).parent().children(".menu").width() - tjq("body").width();
            offsetX = tjq(this).parent().children(".menu").position().left - offsetX - 1;
            tjq(this).parent().children(".menu").css("left", offsetX + "px")
        } else {
            tjq(this).parent().children(".menu").css("left", "0")
        }
    });

    function resizeSlideshowBGHeight() {
        if (tjq(".slideshow-bg.full-screen").length == 1) {
            var offsetTop = tjq(".slideshow-bg.full-screen").offset().top;
            tjq(".slideshow-bg.full-screen").height(tjq(window).height() - offsetTop)
        }
    }
    resizeSlideshowBGHeight();
    tjq(".items-container.isotope").each(function() {
        if (!tjq.fn.isotope) {
            return
        }
        var _container = tjq(this),
            _filter = _container.siblings('.gallery-filter'),
            _links = _filter.find('a');
        var _options = {
            layoutMode: 'fitRows',
            itemSelector: '.iso-item',
            animationEngine: 'best-available',
            resizable: !1,
        };

        function runIsotope() {
            var $container = _container.addClass('active').isotope(_options, function() {
                _container.css({
                    overflow: 'visible'
                })
            })
        };
        _links.bind('click', function() {
            var current = tjq(this),
                selector = current.data('filter');
            _links.removeClass('active');
            current.addClass('active');
            _options.filter = '.' + selector;
            _container.isotope(_options, function() {
                _container.css({
                    overflow: 'visible'
                })
            });
            return !1
        });
        tjq(window).on('debouncedresize', function() {
            _container.isotope("reLayout")
        });
        runIsotope()
    });
    tjq(window).resize(function() {
        tjq(".middle-block").middleblock();
        fixPositionMegaMenu();
        fixPositionSubmenu();
        fixPromoBoxHeight();
        fixTestimonialHeight('.testimonial');
        if (tjq(".photo-gallery.style2").length > 0) {
            tjq(".photo-gallery.style2").each(function() {
                var height = tjq(this).find(".slides img").height();
                tjq(this).find(".flex-control-nav").css("top", (height - 44) + "px")
            })
        }
        resizeSlideshowBGHeight()
    })
});
var megamenu_items_per_column = 6;

function fixPositionMegaMenu(parentObj) {
    if (typeof parentObj == "undefined") {
        parentObj = ""
    } else {
        parentObj += " "
    }
    tjq(parentObj + ".megamenu-menu").each(function() {
        var paddingLeftStr = tjq(this).closest(".container").css("padding-left");
        var paddingLeft = parseInt(paddingLeftStr, 10);
        // var offsetX = tjq(this).offset().left - tjq(this).closest(".container").offset().left - paddingLeft;
        //Farab hack
        var offsetX = tjq(this).offset().left - tjq(this).parent().offset().left - paddingLeft;
        if (offsetX == 0) {
            return
        }
        tjq(this).children(".megamenu-wrapper").css("left", "-" + offsetX + "px");
        tjq(this).children(".megamenu-wrapper").css("width", tjq(this).closest(".container").width() + "px");
        if (typeof tjq(this).children(".megamenu-wrapper").data("items-per-column") != "undefined") {
            megamenu_items_per_column = parseInt(tjq(this).children(".megamenu-wrapper").data("items-per-column"), 10)
        }
        var columns_arr = new Array();
        var sum_columns = 0;
        tjq(this).find(".megamenu > li").each(function() {
            var each_columns = Math.ceil(tjq(this).find("li > a").length / megamenu_items_per_column);
            if (each_columns == 0) {
                each_columns = 1
            }
            columns_arr.push(each_columns);
            sum_columns += each_columns
        });
        tjq(this).find(".megamenu > li").each(function(index) {
            tjq(this).css("width", (columns_arr[index] / sum_columns * 100) + "%");
            tjq(this).addClass("megamenu-columns-" + columns_arr[index])
        });
        tjq(this).find(".megamenu > li.menu-item-has-children").each(function(index) {
            if (tjq(this).children(".sub-menu").length < 1) {
                tjq(this).append("<ul class='sub-menu'></ul>");
                for (var j = 0; j < columns_arr[index]; j++) {
                    tjq(this).children(".sub-menu").append("<li><ul></ul></li>")
                }
                var lastIndex = tjq(this).children("ul").eq(0).children("li").length - 1;
                tjq(this).children("ul").eq(0).children("li").each(function(i) {
                    var parentIndex = Math.floor(i / megamenu_items_per_column);
                    tjq(this).closest("li.menu-item-has-children").children(".sub-menu").children("li").eq(parentIndex).children("ul").append(tjq(this).clone());
                    if (i == lastIndex) {
                        tjq(this).closest(".menu-item-has-children").children("ul").eq(0).remove()
                    }
                })
            }
        });
        tjq(this).children(".megamenu-wrapper").show()
    })
}
fixPositionMegaMenu();
tjq("body").on("click", ".travelo-signup-box .signup-email", function(e) {
    e.preventDefault();
    tjq(this).closest(".travelo-signup-box").find(".simple-signup").hide();
    tjq(this).closest(".travelo-signup-box").find(".email-signup").show();
    tjq(this).closest(".travelo-signup-box").find(".email-signup").find(".input-text").eq(0).focus()
});
tjq(document).ready(function() {
    var pathname = window.location.pathname,
        page = pathname.split(/[/ ]+/).pop(),
        menuItems = tjq('#main-menu a, #mobile-primary-menu a');
    menuItems.each(function() {
        var mi = tjq(this),
            miHrefs = mi.attr("href"),
            miParents = mi.parents('li');
        if (page == miHrefs) {
            miParents.addClass("active").siblings().removeClass('active')
        }
    })
})

/**
 * this function call set detail for google map for show hotel in map
 * @param  float latitude_number
 * @param  float longitude_number
 * @return void
 */
var marker;

function myMap(latitude, longitude) {
    var myCenter = new google.maps.LatLng(latitude, longitude);
    var mapCanvas = document.getElementById("googleMap");
    var mapOptions = {
        center: myCenter,
        zoom: 17
    };
    var map = new google.maps.Map(mapCanvas, mapOptions);
    marker = new google.maps.Marker({
        position: myCenter,
        map: map,
        visible: true,
        draggable: true,
        animation: google.maps.Animation.DROP,

    });

    marker.addListener('click', toggleBounce);
    google.maps.event.addListener(marker, 'dragend', function(evt) {
        document.getElementById('latitude_map').value = evt.latLng.lat().toFixed(5);
        document.getElementById('longitude_map').value = evt.latLng.lng().toFixed(5);
    });
    google.maps.event.addListener(map, "idle", function() {
        google.maps.event.trigger(map, 'resize');
    });

    // when drag start
    // google.maps.event.addListener(marker, 'dragstart', function (evt) {
    // 	document.getElementById('latitude_map').value = evt.latLng.lat().toFixed(5);
    // 	document.getElementById('longitude_map').value = evt.latLng.lng().toFixed(5);
    // });
}

function toggleBounce() {
    if (marker.getAnimation() !== null) {
        marker.setAnimation(null);
    } else {
        marker.setAnimation(google.maps.Animation.BOUNCE);
    }
}

// end of google map api part

var getNameById = function(element, id, url, insuranceType, text) {
    $.ajax({
        type: "POST",
        url: url,
        data: {
            word: id,
            insuranceType: insuranceType
        },
        headers: {
            'CSRF-Token': $('meta[name="CSRFToken"]').attr('content')
        },
        success: function(list) {
            //$('.entry-title').text(list.status);
            $(element).html(text + list.status);
        }
    });
};

$('body').on('click submit', '.confirm_alert', function(e) {

    Swal.fire({
        title: 'توجه',
        text: "آیا از انجام این عمل اطمینان دارید؟",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        cancelButtonText: 'خیر',
        confirmButtonText: 'بله'
    }).then((result) => {
        if (result.value) {

            if ($(this).data('callback')) {
                var fnstring = $(this).data('callback');

                var fnparams = [];
                if ($(this).data('callback-params-csv')) {
                    fnparams = $(this).data('callback-params-csv').toString().split(',');
                }

                var fn = window[fnstring];
                if (typeof fn === "function") {
                    fn.apply(null, fnparams);
                }
            } else {
                if ($(this).is('a')) {
                    window.location.href = this.href;
                } else if ($(this).is('form')) {
                    $('body').off('click submit', '.confirm_alert');
                    $(this).submit();
                }
            }
        }
    });

    e.preventDefault();
});

$('body').on('click', '.new-lang-select', function(event) {
    var $this = $(this);
    if (!$this.data('id') || $this.data('id') === undefined || $this.data('id') === '' || !$this.data('langs') || $this.data('langs') === undefined || $this.data('langs') === '' || !$this.data('url') || $this.data('url') === undefined || $this.data('url') === '') {
        Swal.fire({
            title: 'خطا',
            text: "خطایی رخ داده است، لطفا دوباره سعی نمایید.",
            type: 'error',
            confirmButtonText: 'تایید',
        });

        event.preventDefault();
        return false;
    }

    var item_langs = $this.data('langs').split(',');

    var inputOptions = {};
    for (var key in Locales) {
        if (Locales.hasOwnProperty(key) && item_langs.indexOf(key) === -1) {
            inputOptions[key] = Locales[key].native;
        }
    }

    Swal.fire({
        title: 'توجه',
        text: "لطفا زبان مورد نظر خود را انتخاب نمایید.",
        type: 'info',
        showCancelButton: true,
        cancelButtonText: 'لغو',
        confirmButtonText: 'تایید',
        input: 'select',
        inputOptions: inputOptions,
        inputPlaceholder: 'انتخاب نمایید...',
        inputValidator: (value) => {
            return new Promise((resolve) => {
                if (value && value !== '') {
                    resolve();
                } else {
                    resolve('انتخاب زبان الزامی است.');
                }
            });
        }
    }).then((result) => {
        if (result.value) {
            window.location.href = $this.data('url') + '?lcode=' + result.value + '&brid=' + $this.data('id');
        }
    });
});

<!-- Convert Persian Digits to English and Number Format Digits (add comma after each 3 digits) -->
$(document).ready(function() {
    function Convert_Persian_To_English_Number() {
        var findd = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹', '٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩‎', 'ك', 'ي', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹', '۰'];
        var replacee = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'ک', 'ی', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];

        var str = $(this).val();
        var temp_str = '';

        for (var i = 0; i < str.length; i++) {
            var illegal_char_index = findd.indexOf(str[i]);

            if (illegal_char_index != -1)
                temp_str += replacee[illegal_char_index];
            else
                temp_str += str[i];
            // str[i] = replacee[illegal_char_index];
        }

        $(this).attr('value', temp_str);
        $(this).val(temp_str);
    }
    $(document).on('change', 'input[type="text"], textarea', Convert_Persian_To_English_Number);
    $(document).on('keypress', 'input[type="text"], textarea', Convert_Persian_To_English_Number);
});

$.fn.setCursorPosition = function() {
    this.each(function(index, elem) {
        if (elem.setSelectionRange) {
            elem.setSelectionRange(pos, pos);
        } else if (elem.createTextRange) {
            var range = elem.createTextRange();
            range.collapse(true);
            range.moveEnd('character', pos);
            range.moveStart('character', pos);
            range.select();
        }
    });
    return this;
};

// Number format (add comma after each 3 digits
function number_format(number, decimals, dec_point, thousands_sep) {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
    var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function(n, prec) {
            var k = Math.pow(10, prec);
            return '' + Math.round(n * k) / k;
        };
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}

function number_formatL(number, currency) {
    if(currency == undefined) {
        currency = current_currency;
    }

    switch (currency) {
        case 'IRR' :
            number = number_format(number);
            break;
        case 'USD' :
            number = number_format(number, 2);
            break;
        default :
            number = number_format(number);
    }

    return number;
}

//------------ auto comma prices----------------------
var autoComma = function(number_input) {
    number_input += '';
    var sign = number_input.startsWith("-") ? '-' : '';

    number_input = number_input.split(',').join('');
    x = number_input.split('.');
    x1 = x[0].replace(/\D/g, '');
    x2 = x.length > 1 ? '.' + x[1].replace(/\D/g, '') : '';
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1))
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
    x1 = sign + x1;
    return x1 + x2;
};

$('input[type="tel"]').keyup(function() {
    $(this).val(autoComma($(this).val()));
});
//----------- end auto comma prices------- -----------

//----------- waypoints------- -----------
if (tjq().waypoint && !stGlobals.isMobile) {
    tjq('.animated').waypoint(function() {
        var type = tjq(this).data("animation-type");
        if (typeof type == "undefined" || type == !1) {
            type = "fadeIn"
        }
        tjq(this).addClass(type);
        var duration = tjq(this).data("animation-duration");
        if (typeof duration == "undefined" || duration == !1) {
            duration = "1"
        }
        tjq(this).css("animation-duration", duration + "s");
        var delay = tjq(this).data("animation-delay");
        if (typeof delay != "undefined" && delay != !1) {
            tjq(this).css("animation-delay", delay + "s")
        }
        tjq(this).css("visibility", "visible");
        setTimeout(function() {
            tjq.waypoints('refresh')
        }, 1000)
    }, {
        triggerOnce: !0,
        offset: 'bottom-in-view'
    })
}
if (tjq().waypoint) {
    tjq('.counters-box').waypoint(function() {
        tjq(this).find('.display-counter').each(function() {
            var value = tjq(this).data('value');
            tjq(this).countTo({
                from: 0,
                to: value,
                speed: 3000,
                refreshInterval: 10
            })
        });
        setTimeout(function() {
            tjq.waypoints('refresh')
        }, 1000)
    }, {
        triggerOnce: !0,
        offset: '100%'
    })
} else {
    tjq(".counters-box .display-counter").each(function() {
        var value = tjq(this).data('value');
        tjq(this).text(value)
    })
}